export enum PaymentStatus {
    InProgress = 1,
    Failure = 2,
    Success = 3,
    Refund = 4,
    RefundInProgress = 5,
    RefundFailure = 6,
}

export const paymentStatusLabels = ['', 'In Progress', 'Failure', 'Success', 'Refunded', 'Refund In Progress', 'Refund Failure'];
